import { filter, map, mergeMap } from 'rxjs/operators';

import { showModal } from '../../../app/reducers';
import { portalTypeSelector } from '../../../app/selectors/portal-type.selector';
import { OTP_APPLY_LEGAL_DOCUMENTS } from '../../../domain/config';
import {
  authorizeWithOtpConflict,
  authorizeWithOtpPhoneInUse,
  authorizeWithOtpSuccess,
} from '../../../features/account/reducer/session';
import { loadAnalyticsData } from '../../../features/analytics/reducers/analytics-data';
import { nextStep } from '../../../features/application/reducers/next-step';
import { startOrResumeApplication } from '../../../features/fleet-verification/reducers';
import { recordConsent } from '../../../features/legal-consent/reducers/consent';
import { RootEpic } from '../index';

export const phoneInUseEpic: RootEpic = (action$) =>
  action$.pipe(
    filter(authorizeWithOtpPhoneInUse.match),
    map(() =>
      showModal({
        type: 'user-with-email-and-phone-exists',
        context: null,
      }),
    ),
  );

export const authorizedEpic: RootEpic = (action$, state$) =>
  action$.pipe(
    filter(authorizeWithOtpSuccess.match),
    filter(() => portalTypeSelector(state$.value) === 'apply'),
    mergeMap(() => [
      recordConsent({
        documentKeys: OTP_APPLY_LEGAL_DOCUMENTS,
        onSuccess: [nextStep({ resuming: true, gotoNextPage: true })],
      }),
      loadAnalyticsData(),
    ]),
  );

export const authorizedVerifyEpic: RootEpic = (action$, state$) =>
  action$.pipe(
    filter(authorizeWithOtpSuccess.match),
    filter(() => portalTypeSelector(state$.value) === 'verify'),
    map(() => startOrResumeApplication()),
  );

export const authorizeConflictEpic: RootEpic = (action$) => {
  return action$.pipe(
    filter(authorizeWithOtpConflict.match),
    map(({ payload: { conflict } }) => {
      switch (conflict) {
        case 'existing_coast_account':
          return showModal({
            type: 'user-with-email-exists',
            context: null,
          });
        case 'existing_verify_application':
          return showModal({
            type: 'existing-application',
            context: {
              conflict,
            },
          });
        case 'existing_credit_application':
          return showModal({
            type: 'existing-application',
            context: {
              conflict,
            },
          });
      }
    }),
  );
};
